var $ = jQuery.noConflict();

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = jQuery('.as_website_currency').val()+"{{amount_with_comma_separator}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '0');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function loadBuyTogetherItems(){

    var existing_product = [];

    var posts = $.parseJSON(jQuery('.products_buy_together_list').html());
    var allposts = posts['results'];

    var prices = $.parseJSON(jQuery('.products_all_sale_price').html());
    var allprices = prices['results'][0];

    var price_html = '';
    var html = '';

    setTimeout(function(){

        jQuery('#mini-cart .cart-items-list .minicart-item').each(function(){

            var product_handle = jQuery(this).attr('item-handle');
            var product_properties = jQuery(this).attr('item-proprerties');

            for (var key of Object.keys(allposts)) {

                var post = allposts[key];
                var ph = post['product'];
                var products = post['content'];

                if(ph == product_handle){

                    for (var k of Object.keys(products)) {

                        product = products[k];
                        if(!existing_product.includes(product.handle)){
                        
                            existing_product.push(product.handle);
                            html += '<li class="buy_together_regular">';
            
                                html += '<div>';
            
                                    html += '<div class="buy_together_image"><img src="'+product.featured_image+'" alt="'+product.title+'"></div>';
                                    
                                    html += '<div class="buy_together_description">';
                                        html += '<div>'; 
                                            html += '<div class="buy-together-title">'+product.title+'</div>';
                                            html += '<div class="buy-together-price">'+product.old_price+' <span>'+product.price+'</span></div>';
                                        html += '</div>';
                                    html += '</div>';

                                    html += '<div class="buy_together_atc">';
                                        html += '<div class="as-product-atc-button as-button tiny-button blue-button" qty="1" product_id="'+product.id+'" selling_plan="">Zum Einkaufswagen hinzufügen</div>';
                                    html += '</div>';
            
                                html += '</div>';  
            
                            html += '</li>';  
                        
                        }
        
                    }

                }

            }

            if(allprices[product_handle] != undefined){

                var price_object = allprices[product_handle][0];
                //console.log(price_object);
                price_html += '<div class="td-price has_price_discount">';
                    price_html += '<span class="item-price-discounted price">'+price_object['price']+'</span>';
                    price_html += '<span class="item-price price">'+price_object['old_price']+'</span>';
                price_html += '</div>';

                jQuery(this).find('.td-price').replaceWith(price_html);
                    
            }

            /*  */

        });

    },300);
    
    setTimeout(function(){

        if(html != ''){

            jQuery('.cart-buy-together-items').wrapInner( "<ul></ul>");
            jQuery('.cart-buy-together-items').prepend( "<h6>Buy together and save!</h6>" );
            jQuery('.cart-buy-together-items ul').html(html);

        }else{
            jQuery('.cart-buy-together-items').html('');
        }

    },600);

}

function loadMinicartData(){

    $.getJSON('/cart.js', function(data) {
        
        // run template view
        var template = $("#minicart-template").html();
        var tmpl = _.template(template);
        
        // populate cart data
        $("#mini-cart").html(tmpl({cart:data}));
        
        // format all prices
        $('.price', '#mini-cart').each(function() {
            $(this).html( Shopify.formatMoney($(this).text()) );
        });
        
        // format image to small
        $('img', '#mini-cart').each(function() {
            var src = $(this).attr('src');
            src = src.replace('.jpg', '_50x50.jpg'); // if using jpg
            src = src.replace('.jpeg', '_50x50.jpeg'); // if using jpeg
            $(this).attr('src', src);
        });
        
        $('#mini-cart').addClass('visible');
        $('body').addClass('visible-minicart');

    });

    loadBuyTogetherItems();

    setTimeout(function(){jQuery('#mini-cart').removeClass('loading');},4000);

}


function check_if_in_view_OneWay() {

    var lazy_elements = jQuery('.lazy-background,.lazy-image');
    var benefits = jQuery('.benefit-item');
    var sticky_mobile = jQuery('#shopify-section-supernaturals-product-list');
    var window_height = jQuery(window).height();
    var window_top_position = jQuery(window).scrollTop();
    var halfscreen =  (window_height / 2);

    if(jQuery(window).width() < 768 ){
        var top_extra = 10; 
    }else{    
        var top_extra = 300; 
    }

    var window_bottom_position = window_top_position + window_height + top_extra;

    jQuery.each(lazy_elements, function() {
        var element = jQuery(this);
        var element_height = element.outerHeight();
        var element_top_position = element.offset().top;
        var element_bottom_position = (element_top_position + element_height);
        if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
            
            if(element.hasClass('lazy-image')){
            
            var img = element.attr('data-src');
            element.attr('src',img);
            
            }else{
            
            var bg = element.attr('data-bg');
            element.css('background-image','url('+bg+')');
            
            }
            
        }
    });
  
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function get_header_height(){

    var hh = 0;

    if(jQuery('.site-header-announcement').length){
        hh = hh + parseInt(jQuery('.site-header-announcement').outerHeight());
    }

    if(jQuery('.site-header').length){
        hh = hh + parseInt(jQuery('.site-header').outerHeight());
    }

    return hh;

}

function custom_dropdown_view(element){

    var drop_elements = '.field__select_custom';
    var provinces_opt = '';
    if(element.length){
        drop_elements = element;
    }
    jQuery(drop_elements).each(function(){

        var sel = jQuery(this);
        sel.addClass('field__select_custom').wrap('<div class="dropdown__custom_view"></div>');

        var selected_option = sel.val();

        if(selected_option == ''){
            selected_option = sel.find('option:first-child').html();
        }

        var country_default = '';
        if(sel.attr('data-default') != undefined){
            country_default = sel.attr('data-default');
            selected_option = country_default;
            console.log('case1');
        }

        var html = '';
        html += '<div class="dropdown__custom_selected"><span>'+ selected_option +'</span></div>';

        html += '<div class="dropdown__custom_options">';

            sel.find('option').each(function(){

                var optval = jQuery(this).attr('value');
                var opthtml = jQuery(this).html();
                var custom_class = '';

                if(jQuery(this).attr('data-provinces') !== undefined){

                    provinces_opt = jQuery(this).attr('data-provinces');
                    if(provinces_opt != '[]'){
                        custom_class = 'has-province-item';
                    }

                }

                var selected = '';
                if(selected_option == optval){
                    selected = 'active';
                }

                html += '<div class="dropdown__custom_option '+custom_class+' '+selected+'" optval="'+optval+'">'+opthtml+'</div>';

            });

        html += '</div>';

        sel.after(html);

    });

}

function resetDropdownView(element){
    jQuery(element).parent().find('div').remove();
    jQuery(element).unwrap();
    custom_dropdown_view(element);
}

function paginate_to_blog(page,posts_per_page){

    jQuery('.filter_loading').fadeIn();
    var posts = $.parseJSON(jQuery('.articles_json_container').html());

    var html = '';
    if(parseInt(page) > 0){
        page = parseInt(page) - 1;
    }
    var min_pag = parseInt(page * posts_per_page);
    var max_pag = parseInt(min_pag) + parseInt(posts_per_page);
    var allposts = posts['results'];

    for (var i = min_pag;i < max_pag;i++) {

        if(allposts[i]){

            var post = allposts[i];
            html += '<li class="as-blogpost-item transition load_blogpost" post_filters="'+post.tags+'">';

                html += '<div class="blogpost-image lazy-background" data-bg="'+post.image+'">';
                    html += '<a href="'+post.url+'" title="'+post.title+'" class="anchor_overlay"></a>';
                html += '</div>';

                html += '<div class="blogpost-item-content">';
                    html += '<div>';

                        html += '<div class="blog-item-badge"></div>';

                        html += '<div class="post_date">'+post.date+'</div>';

                        html += '<div class="post_title"><a href="'+post.url+'" title="'+post.title+'">'+post.title+'</a></div>';

                        html += '<div class="post_excerpt">'+post.excerpt+'</div>';

                        html += '<div class="button-container">';
                            html += '<a class="as-button text-button" href="'+post.url+'"><span>Mehr erfahren</span></a>';
                        html += '</div>';

                    html += '</div>';
                html += '</div>';
                
            html += '</li>';

        }

    }
    
    jQuery('.blog-module-list-items ul').html(html);

    setTimeout(function(){
        check_if_in_view_OneWay();
    },20);

    setTimeout(function(){
        jQuery("html, body").animate({ scrollTop: 0 }, 500);
    },100)

    setTimeout(function(){
        jQuery('.as-blogpost-item').removeClass('load_blogpost');
        jQuery('.filter_loading').fadeOut();
    },400);

}

function resetBlogPagination(posts_per_page){

    var posts = $.parseJSON(jQuery('.articles_json_container').html());
    var allposts = posts['results'];
    var pagination_html = '';
    var item_class = '';

    var pagination_count = Math.ceil(allposts.length / posts_per_page);

    for(var i=1;i<=pagination_count;i++){

        if(i==1){
            item_class = 'active';
        }else{
            item_class = '';
        }

        pagination_html += '<li page_go_to="'+i+'" class="'+item_class+'">'+i+'</li>';

    }

    jQuery('.as-paginate-numbers').html(pagination_html).attr('pages_size',pagination_count);
    jQuery('.paginate_prev_btn, .paginate_next_btn').addClass('inactive');
    if(pagination_count > 1){
        jQuery('.paginate_next_btn').removeClass('inactive');
    }
    
}

function arrayContains(needle, arrhaystack){
    return (arrhaystack.indexOf(needle) > -1);
}

function addItemToCart(variant_id, qty, selling_plan, product_id,variant_name ) {

    data = {};
    items = {};

    if (variant_id.indexOf(',') > -1) {
        
        var ids = variant_id.split(',');
        for(x in ids){
            items[x] = {"id": ids[x],"quantity": qty,"selling_plan": selling_plan};
        }
        data = {items:items};

    }else{
        data = {"id": variant_id,"quantity": qty,"selling_plan": selling_plan}
    }

    //console.log(data);
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(result) {
        //window.location.href = '/cart'; 
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            jQuery('.cart-counter-main-item').html(cart.item_count);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    });

}

function updateItemToCart(line, qty, variant_id) {

    data = {
        "line": line,
        'variant_id': variant_id,
        "quantity": qty
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function(result) {
        //window.location.href = '/cart'; 
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {

            jQuery('.cart-counter-main-item').html(cart.item_count);

            setTimeout(function(){
                loadMinicartData();
            },500);

            setTimeout(function(){
                jQuery('#mini-cart').removeClass('loading');
            },1500);
            
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    });

}

function pdpFixedAddToCartButton(){
    if(jQuery('.add_to_cart_position').length){

        if (jQuery('.footer.site-footer').isInViewport()) {

            jQuery('.as-add-to-cart-mobile').removeClass('visible');
            
        } else {

            var element_top_pos = jQuery('.add_to_cart_position').offset().top;
            var window_top_position = jQuery(window).scrollTop();
            var window_height = jQuery(window).height();
            var element_height = jQuery('.add_to_cart_position').outerHeight();

            var elm1 = window_top_position + window_height;
            var elm2 = element_top_pos + window_height + element_height - get_header_height();

            if(elm1 > elm2){
                jQuery('.as-add-to-cart-mobile').addClass('visible');
            }else{
                jQuery('.as-add-to-cart-mobile').removeClass('visible');
            }

        }

    }
}

function scrollTopVisibleButton(){

    var window_top_position = jQuery(window).scrollTop();
    var window_height = parseInt(jQuery(window).height()) / 2;

    if(window_top_position > window_height){
        jQuery('.back-to-top-button-general').addClass('visible');
    }else{
        jQuery('.back-to-top-button-general').removeClass('visible');
    }

}

jQuery(window).on('scroll', function() {

    //check_if_in_view_OneWay();
    pdpFixedAddToCartButton();
    scrollTopVisibleButton();

});

jQuery(document).ready(function(){

    jQuery('.as-customer-menu-widget').on('click',function(){
        jQuery(this).find("ul").toggleClass('open--drop');
        jQuery(this).toggleClass('open--head');
    });

    jQuery('.as-customer-menu-widget ul li').on('click',function(){
        var textx = jQuery(this).find("a").text();
        jQuery('.as-customer-menu-widget .menu--hilder').text(textx);
    });

    //check_if_in_view_OneWay();
    custom_dropdown_view('');

    jQuery('body').on('click','.close-search-modal-item',function(){
        jQuery('.header-icon-item.search-icon .header__icon').click();
    });

    if(jQuery('.order-today-carousel-list')){
        jQuery('.order-today-carousel-list').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
    

    if(jQuery('.testimonial_active_carousel').length){

        if(jQuery('.testimonial-main-carousel').length){
            jQuery('.testimonial-main-carousel').slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                asNavFor: '.testimonial_active_carousel'
            });
        }

        jQuery('.testimonial_active_carousel').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.testimonial-main-carousel'
        });

    }else{

        if(jQuery('.testimonial-main-carousel').length){
            jQuery('.testimonial-main-carousel').slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
        }

    }

    jQuery(".piece-ping").on({
		mouseenter: function () {

			var index = jQuery(this).attr('map-pin');
            jQuery(this).addClass('hovered');

            if(index == '1' || index == '2'){
                jQuery('#map-piece-1').addClass('hovered');
            }else{
                jQuery('#map-piece-'+index).addClass('hovered');
            }

            jQuery('[location_card="'+index+'"].store-location-item').addClass('hovered');

		},
		mouseleave: function () {
			jQuery('.hoverable-map-piece, .piece-ping, .store-location-item').removeClass('hovered');
		}
	});

    jQuery(".hoverable-map-piece").on({
		mouseenter: function () {

			var index = jQuery(this).attr('map-piece');
            var group = index;

            if(index == '1'){
                group = '1';
            }

            jQuery(this).addClass('hovered');
            jQuery('#map-piece-'+group).addClass('hovered');

            if(index == '1'){
                jQuery('.piece-ping-1').addClass('hovered');
                jQuery('.piece-ping-2').addClass('hovered');
            }else{
                jQuery('.piece-ping-'+index).addClass('hovered');
            }
            
            jQuery('[location_card="'+index+'"].store-location-item').addClass('hovered');

		},
		mouseleave: function () {
			jQuery('.hoverable-map-piece, .piece-ping, .store-location-item, .piece-ping ').removeClass('hovered');
		}
	});

    jQuery(".store-location-item").on({
		mouseenter: function () {

			var index = jQuery(this).attr('location_card');
            jQuery(this).addClass('hovered');

            if(index == '1' || index == '2'){
                jQuery('#map-piece-1').addClass('hovered');
            }else{
                jQuery('#map-piece-'+index).addClass('hovered');
            }

            jQuery('.piece-ping-'+index).addClass('hovered');

		},
		mouseleave: function () {
			jQuery('.hoverable-map-piece, .piece-ping, .store-location-item, .piece-ping ').removeClass('hovered');
		}
	});

    jQuery('body').on('click','.ex-top-list .as-button.small-button', function(){
        
        var index = jQuery(this).parents('.store-location-item').index();
        var scroll_element = jQuery('.store-exhibition-item').eq(index);

        jQuery("html, body").animate({ scrollTop: scroll_element.offset().top - get_header_height() }, 1000);

    });

    jQuery('body').on('click','.piece-ping', function(){
        
        var index = jQuery(this).attr('map-pin');
        var scroll_element = jQuery('.store-exhibition-item:nth-child('+index+')');

        jQuery("html, body").animate({ scrollTop: scroll_element.offset().top - get_header_height() }, 1000);

    });

    if(jQuery('.date_time_field').length){
        jQuery.datetimepicker.setLocale('de');
        jQuery('.date_time_field').datetimepicker({
            i18n:{
                de:{
                    months:[
                    'Januar','Februar','März','April',
                    'Mai','Juni','Juli','August',
                    'September','Oktober','November','Dezember',
                    ],
                    dayOfWeek:[
                    "Sonntag", "Montag", "Dienstag", "Mittwoch","Donnerstag", "Freitag", "Samstag"
                    ]
                }
            },
            format:'d.m.Y H:i',
            lang: 'de',
            minDate:'1'
        });
    }

    jQuery('body').on('click','.contact__form_submit',function(){

        var form = jQuery(this).parents('form');
        var errors = 0;

        form.find('.required').each(function(){

            if(jQuery(this).hasClass('validate-email')){

                if(validateEmail(jQuery(this).val())){
                    jQuery(this).parents('.field').removeClass('error');
                }else{
                    errors = 1;
                    jQuery(this).parents('.field').addClass('error');
                }

            }else{

                if(jQuery(this).val().length < 1){
                    errors = 1;
                    jQuery(this).parents('.field').addClass('error');
                }else{
                    jQuery(this).parents('.field').removeClass('error');
                }

            }

        });

        if(errors == 0){
            if(form.find('.acceptance-field input').is(':checked')){
                form.submit();
            }else{
                form.find('.acceptance-field').addClass('error');
            }
        }
        
    });

    jQuery('body').on('click','.as-search-tab',function(){

        var ind = jQuery(this).index();
        jQuery('.as-search-tab, .as-search-tab-content').removeClass('active');

        jQuery(this).addClass('active');
        jQuery('.as-search-tab-content').eq(ind).addClass('active');

    });

    jQuery('body').on('click','.paginate_next_btn', function(){

        var next_page = jQuery('.as-blog-pagination-inner ol li.active').next().attr('page_go_to');
        var posts_per_page = jQuery('.as-blog-pagination').attr('posts_per_page');
        jQuery('.as-blog-pagination-inner ol li.active').removeClass('active').next().addClass('active');

        if(jQuery('.as-blog-pagination-inner ol li:last-child').hasClass('active')){
            jQuery('.paginate_next_btn').addClass('inactive');
        }else{
            jQuery('.paginate_next_btn').removeClass('inactive');
        }

        if(jQuery('.as-blog-pagination-inner ol li:first-child').hasClass('active')){
            jQuery('.paginate_prev_btn').addClass('inactive');
        }else{
            jQuery('.paginate_prev_btn').removeClass('inactive');
        }

        paginate_to_blog(next_page,posts_per_page);

    });

    jQuery('body').on('click','.paginate_prev_btn', function(){

        var next_page = jQuery('.as-blog-pagination-inner ol li.active').prev().attr('page_go_to');
        var posts_per_page = jQuery('.as-blog-pagination').attr('posts_per_page');
        jQuery('.as-blog-pagination-inner ol li.active').removeClass('active').prev().addClass('active');

        if(jQuery('.as-blog-pagination-inner ol li:last-child').hasClass('active')){
            jQuery('.paginate_next_btn').addClass('inactive');
        }else{
            jQuery('.paginate_next_btn').removeClass('inactive');
        }

        if(jQuery('.as-blog-pagination-inner ol li:first-child').hasClass('active')){
            jQuery('.paginate_prev_btn').addClass('inactive');
        }else{
            jQuery('.paginate_prev_btn').removeClass('inactive');
        }

        paginate_to_blog(next_page,posts_per_page);

    });

    jQuery('body').on('click','.as-paginate-numbers li:not(.active)',function(){
        
        var next_page = jQuery(this).attr('page_go_to');
        var posts_per_page = jQuery('.as-blog-pagination').attr('posts_per_page');
        jQuery('.as-blog-pagination-inner ol li.active').removeClass('active');
        jQuery(this).addClass('active');

        if(jQuery('.as-blog-pagination-inner ol li:last-child').hasClass('active')){
            jQuery('.paginate_next_btn').addClass('inactive');
        }else{
            jQuery('.paginate_next_btn').removeClass('inactive');
        }

        if(jQuery('.as-blog-pagination-inner ol li:first-child').hasClass('active')){
            jQuery('.paginate_prev_btn').addClass('inactive');
        }else{
            jQuery('.paginate_prev_btn').removeClass('inactive');
        }

        paginate_to_blog(next_page,posts_per_page);
        
    });

    jQuery('body').on('click','.blog-module-filters ul li',function(){

        var posts_per_page = parseInt(jQuery('.as-blog-pagination').attr('posts_per_page'));
        var tag = jQuery(this).attr('tag_slug');
        jQuery('.blog-module-filters ul li').removeClass('active');
        jQuery(this).addClass('active');

        if(tag == '*'){

            jQuery('.articles_json_container').html(jQuery('.articles_json_container_bkp').html());
            jQuery('.blog-featured-post').removeClass('hidden_fade').fadeIn();

        }else{
 
            if(jQuery('.as-blogpost-item.item_collection_featured').length){
                var featured_tags = jQuery('.as-blogpost-item.item_collection_featured').attr('post_filters');
                var featured_tags_Array = featured_tags.split(',');
                if(arrayContains(tag,featured_tags_Array)){
                    jQuery('.blog-featured-post').removeClass('hidden_fade').fadeIn();
                }else{
                    jQuery('.blog-featured-post').addClass('hidden_fade').fadeOut();
                }
            }

            var posts = $.parseJSON(jQuery('.articles_json_container_bkp').html());
            var allposts = posts['results'];

            var new_json_inner = '';
            var new_json = '{';
                new_json += '"result_count": "category",';
                new_json += '"results": [';

                    for (var key of Object.keys(allposts)) {

                        var post = allposts[key];
                        var taglist = post['tags'];
                        if(arrayContains(tag,taglist)){
                            new_json_inner += '{';
                                new_json_inner += '"title":"'+post.title+'",';
                                new_json_inner += '"url":"'+post.url+'",';
                                new_json_inner += '"image":"'+post.image+'",';
                                new_json_inner += '"date":"'+post.date+'",';
                                new_json_inner += '"excerpt":"'+post.excerpt+'",';
                                new_json_inner += '"tags":"'+post.tags+'"';
                            new_json_inner += '},';
                        }
                        
                    }

                    new_json += new_json_inner.slice(0, -1);

                new_json += ']';
            new_json += '}';

            jQuery('.articles_json_container').html(new_json);

        }

        setTimeout(function(){
            paginate_to_blog(0,posts_per_page);
        },50);

        setTimeout(function(){
            resetBlogPagination(posts_per_page);
        },100);

    });

    jQuery('body').on('click','.faq-group-boxes .inner-faq-items li',function(){
        var go_to = jQuery(this).attr('go_to_item');
        $parent = jQuery(this).parents('.as-faqs-section');
        jQuery("html, body").animate({ scrollTop: $parent.find('#'+go_to).offset().top - get_header_height() }, 1000);
    });

    jQuery('body').on('click','.dropdown__custom_selected',function(){
        jQuery(this).parents('.dropdown__custom_view').toggleClass('dp_active');
    });

    jQuery('body').on('click','.dropdown__custom_option',function(){

        var clicked = jQuery(this);
        var clicked_val = clicked.attr('optval');
        var clicked_html = clicked.html();

        clicked.parents('.dropdown__custom_options').find('.dropdown__custom_option').removeClass('active');
        clicked.addClass('active');

        var id = clicked.parents('.dropdown__custom_view').find('select.field__select_custom').attr('id');
        var input = document.querySelector("#"+id);

        clicked.parents('.dropdown__custom_view').find('.dropdown__custom_selected span').html(clicked_html);
        clicked.parents('.dropdown__custom_view').find('select.field__select_custom').val(clicked_val).trigger('change');

        input.dispatchEvent(new Event('change', { bubbles: true }));

        clicked.parents('.dropdown__custom_view').removeClass('dp_active');

        if(jQuery(this).hasClass('has-province-item')){
            resetDropdownView('[name="address[province]"].field__select_custom');
        }

    });

    jQuery(document).bind('click', function(e) {
        if(jQuery(e.target).closest('.dropdown__custom_view').length === 0) {
            jQuery('.dropdown__custom_view').removeClass('dp_active');
        }
    });

    jQuery('body').on('click','button[aria-controls="AddAddress"],#address_form_new button[type="reset"]',function(){
        jQuery('body').attr('address_behaviour',jQuery('button[aria-controls="AddAddress"]').attr('aria-expanded'));
    });

    if(jQuery('.product-images-carousel-main')){
        jQuery('.product-images-carousel-main').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "0",
            asNavFor: '.product-images-carousel-thumbnails',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        dots: true
                    }
                }
            ]
        });
    }

    var product_img_carousel = 5;

    jQuery('.product-images-carousel-thumbnails').on('init', function(event, slick){        
        var thisSliderCount = parseInt(jQuery('.product-images-carousel-thumbnails').attr('thumbnailsCount'));
        if(thisSliderCount < product_img_carousel){
            jQuery('.product-images-carousel-thumbnails').addClass('center-items-manually');
        }
    });

    if(jQuery('.product-images-carousel-thumbnails')){
        jQuery('.product-images-carousel-thumbnails').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: product_img_carousel,
            slidesToScroll: 1,
            variableWidth: true,
            focusOnSelect: true,
            centerMode: true,
            centerPadding: "0",
            asNavFor: '.product-images-carousel-main'
        });
    }

    jQuery('body').on('click','.as-product-atc-button',function(){
    
        $parent = jQuery('.product-details-column');
        var product_id = jQuery(this).attr('product_id');

        if(jQuery('.variant-pdp-dropdown').length){
            product_id = jQuery('.variant-pdp-dropdown').val();
        }

        var qty = jQuery(this).attr('qty');
        var selling_plan = jQuery(this).attr('selling_plan');

        jQuery('#mini-cart').addClass('loading');

        if($parent.find('.buy_together_regular input[type="checkbox"]:checked').length){

            $parent.find('.buy_together_regular input[type="checkbox"]:checked').each(function(){

                var b_product_id = jQuery(this).attr('product_id');
                product_id += ','+b_product_id;
    
            });

        }

        addItemToCart(product_id, qty, selling_plan, product_id);
        
        setTimeout(function(){
            loadMinicartData();
        },500);
        
    });

    jQuery('body').on('click','.header-icon-item.cart-icon', function() {
        loadMinicartData();
    });

    jQuery('body').on('click','.cart_close_button,.modal-open-overlay',function(){
        jQuery('#mini-cart').removeClass('visible');
        jQuery('body').removeClass('visible-minicart');
    });

    jQuery('body').on('click','.delete-item-from-cart',function(){
    
        var qty = 0;
        var key = jQuery(this).parents('.minicart-item').attr('item-key');
        var variant_id = jQuery(this).attr('product_id');

        updateItemToCart(key, qty, variant_id);

        jQuery('#mini-cart').addClass('loading'); 

        /*
        setTimeout(function(){
            loadMinicartData();
        },500);
        */
        
    });

    jQuery('body').on('click','.js-qty__adjust', function(){

		var max = parseInt(jQuery(this).parent().find('.js-qty-num').attr('data-max'));
		var min = parseInt(jQuery(this).parent().find('.js-qty-num').attr('data-min'));

		var value = parseInt(jQuery(this).parent().find('.js-qty-num').val());

		if(jQuery(this).hasClass('js-qty__adjust--plus')){

			if(value < max){
				value = value + 1;
			}

		}else{

			if(value > min){
				value = value - 1;
			}
			
		}

		jQuery(this).parent().find('.js-qty-num').val(value).trigger('change');

	});

	jQuery('body').on('keyup paste','.js-qty-num',function(){

		this.value = this.value.replace(/[^0-9]/g, '');

		var max = parseInt(jQuery(this).parent().find('.js-qty-num').attr('data-max'));
		var value = parseInt(jQuery(this).parent().find('.js-qty-num').val());

		if(value > max){
			value = max;
			jQuery(this).val(value).trigger('change');
		}

	});

	jQuery('body').on('change','.js-qty-num',function(){

        var qty = jQuery(this).val();
        var key = jQuery(this).parents('.minicart-item').attr('item-key');
        var variant_id = jQuery(this).attr('product_id');

        updateItemToCart(key, qty, variant_id);

        jQuery('#mini-cart').addClass('loading'); 

        /*
        setTimeout(function(){
            loadMinicartData();
        },500);
        */

	});

    jQuery('.stripes').click(function(){
		jQuery(this).toggleClass('activeclose');
		jQuery('body').toggleClass('menu-open');
	});

    jQuery('body').on('click', '.close--predictive',function(){
        jQuery('predictive-search').attr('open', 'false');
        console.log('asdfasdfas');
    });

    /*
    jQuery('body').on('click', '.header-menu-inner .main-menu li.has-child > .open_mobile_submenu_item',function(e){
        if(jQuery(window).width() < 1024){
            e.preventDefault();
            jQuery(this).parent().addClass('open---sub');
        }
    });
    */

    jQuery('.header-menu-inner > ul.main-menu ul.child').append('<span class="close--subb"><span></span><span></span></span>');

    jQuery('body').on('click', '.close--subb',function(e){
        if(jQuery(window).width() < 1024){
            e.preventDefault();
            jQuery('.main-menu > li.has-child').removeClass('open---sub');
        }
    });

    jQuery('body').on('click', '.header-menu-inner .main-menu li.has-child > a,.header-menu-inner .main-menu li.has-child > .open_mobile_submenu_item',function(e){
        if(jQuery(window).width() < 1024){
            
            var attr = $(this).attr('href');
            if (typeof attr !== 'undefined' && attr !== false) {
                if(attr == '/collections'){
                    e.preventDefault();
                    jQuery(this).parent().addClass('open---sub');
                }
            }

            if(jQuery(this).hasClass('open_mobile_submenu_item')){

                jQuery(this).parent().addClass('open---sub');

            }
            
        }
    });

    jQuery('.mobile-close').click(function(){
		jQuery('.stripes').removeClass('activeclose');
		jQuery('body').removeClass('menu-open');
        jQuery('.main-menu > li.has-child').removeClass('open---sub');
	});

    jQuery('.footer__blocks-wrapper p.footer-block__heading').on('click',function(){
        jQuery(this).parent().toggleClass('open--sub-foot');
        jQuery(this).toggleClass('open--head--foot');
    });

    jQuery('body').on('click','.pdp_description_tab_item',function(){

        jQuery('.pdp_description_tab_item,.pdp_description_tab_content').removeClass('active');
        jQuery(this).addClass('active');
        var index = jQuery(this).attr('tab_index');
        jQuery('.pdp_description_tab_content[tab_index="'+index+'"]').addClass('active');

    });

    jQuery('body').on('click','.scroll_top_0,.back-to-top-button, .back-to-top-button-general', function(e){
        e.preventDefault();
        jQuery("html, body").animate({ scrollTop: 0 }, 500);
    });

    if(jQuery('body:not(.template-index) .best-sellers-product-list .as-product-list').length){
        jQuery('body:not(.template-index) .best-sellers-product-list .as-product-list').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      variableWidth: false,
                      slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                      slidesToShow: 1,
                      variableWidth: false,
                      slidesToScroll: 1
                    }
                }
            ]
        });
    }

    if(jQuery('.template-index .best-sellers-product-list .as-product-list').length){
        jQuery('.template-index .best-sellers-product-list .as-product-list').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                      centerMode: true,
                      slidesToShow: 2,
                      variableWidth: false,
                      slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 639,
                    settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      variableWidth: false,
                      slidesToScroll: 1
                    }
                }
            ]
        });
    }

    jQuery('body').on('click','.mobile_clickable_label',function(){
        jQuery(this).parents('.mobile-facets__details.js-filter').toggleClass('active_mobile_filter');
    });

    jQuery('body').on('click','.mobile_collection_filters_close, .mobile_button_close_filters',function(){
        jQuery('.mobile-facets__open-wrapper.focus-offset').click();
    });

    jQuery('body').on('click','.active-facets__button,details .mobile-facets__label,.active-facets__button-remove.underlined-link',function(){

        setTimeout(function(){

            if(jQuery('#FacetFiltersPillsForm facet-remove').length > 1){
                jQuery('facet-filters-form').addClass('make--visible');
            }else{
                jQuery('facet-filters-form').removeClass('make--visible');
            }

            //alert(jQuery('#FacetFiltersPillsForm facet-remove').length);
        },1200);

    });

    if(jQuery('.collection-blogposts-module .as-blogposts-list')){
        jQuery('.collection-blogposts-module .as-blogposts-list').slick({
            dots: true,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            autoplay: false,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 639,
                    settings: 'unslick'
                }
            ]
        });
    }

    jQuery('body').on('click','.pdp_mobile_tab_title',function(){

        jQuery('.pdp_description_tab_content').not(jQuery(this).parents('.pdp_description_tab_content')).removeClass('active');

        if(jQuery(this).parents('.pdp_description_tab_content').hasClass('active')){
            jQuery(this).parents('.pdp_description_tab_content').removeClass('active');
        }else{
            jQuery(this).parents('.pdp_description_tab_content').addClass('active');
        }

        var scroll_element = jQuery(this);

        setTimeout(function(){
            jQuery("html, body").animate({ scrollTop: scroll_element.offset().top - get_header_height() }, 800);
        }, 800);
        
    });

    var marquee = $('div.announcement-text');
    marquee.each(function() {

        if(jQuery(window).width() < 1024){

            var mar = $(this),indent = mar.width();
            mar.marquee = function() {
                indent--;
                mar.css('text-indent',indent);
                if (indent < -1 * mar.children('div.marquee-text').width()) {
                    indent = mar.width();
                }
            };
            mar.data('interval',setInterval(mar.marquee,1000/60));

        }
        
    });

    jQuery('body').on('click','#MainContent a', function(e){

        var id = jQuery(this).attr('href');

        if(id.indexOf("#") !== -1){

            if(!jQuery('.customer').length){

                e.preventDefault();

                const new_id_array = id.split("#");
                var new_id = new_id_array[1];
                
                if(jQuery("#"+new_id).length){

                    jQuery('html, body').animate({
                        scrollTop: jQuery("#"+new_id).offset().top - get_header_height()
                    }, 500);

                }

            }

        }

	});

    jQuery('body').on('click','.pdp-read-more-btn',function(){

        if(jQuery('.product-description-tabs-container').length){

            jQuery("html, body").animate({ scrollTop: jQuery('.product-description-tabs-container').offset().top - get_header_height() }, 1000);

        }

    });

    /* Adding variant functionality */
    jQuery('body').on('change','.variant-pdp-dropdown',function(){

        var price = Shopify.formatMoney(jQuery(this).find('option:selected').attr('variant_price'));
        jQuery(this).parents('.product-information-column.product-details-column').find('.as-price').html(price);

    });
    /* END - Adding variant functionality */

    /* Artesian modal */
    if(Cookies.get('modal_event_27_5_2024') != undefined && Cookies.get('modal_event_27_5_2024') == 'true'){
        
    }else{
        jQuery('.artesian-modal-main').addClass('visible__modal');
    }

    jQuery('body').on('click','.artesian-modal-main-close, .artesian-modal-button-close', function(){
        jQuery('body').addClass('remove_main_modal');
        Cookies.set('modal_event_27_5_2024', 'true', { expires: 10 });
    });
    /* END - Artesian modal */
    
});

jQuery(window).load(function(){	 

    jQuery('#ContactFooter').attr('onsubmit','');
	jQuery('.store-exh-map').each(function(){
		var mapid = jQuery(this).attr('id');
		
		var latitude = jQuery(this).attr('lat');
		var longitude = jQuery(this).attr('long');
		var pinkmarker = jQuery(this).attr('pin');	
		var latlng = new google.maps.LatLng(latitude,longitude);

        var x = 72;
        var y = 110;

        if(jQuery(window).width() < 767){
            var x = 46;
            var y = 64;
        }
        
		// Creating an object literal containing the properties we want to pass to the map  
		var options = {  
			zoom: 15, // This number can be set to define the initial zoom level of the map
			center: latlng,
			zoomControl: false,
			streetViewControl: false,
			mapTypeControl: false,
			disableDefaultUI: true,
			mapTypeId: google.maps.MapTypeId.ROADMAP, // This value can be set to define the map type ROADMAP/SATELLITE/HYBRID/TERRAIN
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative.locality","elementType":"labels.icon","stylers":[{"color":"#bd081c"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}]
		};  
		// Calling the constructor, thereby initializing the map  
		var map1 = new google.maps.Map(document.getElementById( mapid ), options);  		
		var image = {
	        url: pinkmarker,
	        size: new google.maps.Size(x, y),
	        scaledSize: new google.maps.Size((x/2),(y/2)), 
	        origin: new google.maps.Point(0, 0),
	        anchor: new google.maps.Point((x/4), (y/2))
	    };		
		// Add Marker
		var marker2 = new google.maps.Marker({
			position: new google.maps.LatLng(latitude,longitude), 
			map: map1,		
			icon: image // This path is the custom pin to be shown. Remove this line and the proceeding comma to use default pin
		});	
			
	
	});
	
});

jQuery(window).on('resize', function() {

    if(jQuery('.best-sellers-product-list .as-product-list').length){
        jQuery('.best-sellers-product-list .as-product-list').slick('resize');
    }

    if(jQuery('.collection-blogposts-module .as-blogposts-list').length){
        jQuery('.collection-blogposts-module .as-blogposts-list').slick('resize');
    }
    
});